<div class="actions-container">
  <topo-action-menu #menu
    [item]="document"
    [appendToBody]="true">
    @for (action of actions; track action.label) {
      <topo-action
        label="{{ action.label }}"
        icon="{{ action.icon }}"
        divider="{{ action.divider }}"
      (actionClick)="actionClick(action)"></topo-action>
    }
  </topo-action-menu>
</div>
